'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWithStore = undefined;

var _getContext3 = require('recompose/getContext');

var _getContext4 = _interopRequireDefault(_getContext3);

var _withContext3 = require('recompose/withContext');

var _withContext4 = _interopRequireDefault(_withContext3);

var _compose2 = require('recompose/compose');

var _compose3 = _interopRequireDefault(_compose2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createWithStore = exports.createWithStore = function createWithStore() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return (0, _compose3.default)((0, _withContext4.default)(_defineProperty({}, storeKey, _propTypes2.default.object), function () {}), (0, _getContext4.default)(_defineProperty({}, storeKey, _propTypes2.default.object)));
};

exports.default = createWithStore();


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-firebase/es/withStore.js
// module id = 481
// module chunks = 1